export const PHOEBE_THINKING_TIPS = [
    'Phoebe knows if a caregiver is assigned a shift in your EHR.',
    'You can set up Phoebe in a Slack channel.',
    'Phoebe will never call a caregiver while they are on a shift. Phoebe can only text them.',
    'You can set up Quiet Hours that Phoebe will not call your caregivers.',
    'Phoebe recommends including at least 15 caregivers per outreach, if possible.',
    "You can set up a daily digest to review your agency's activity over the day.",
    'Phoebe can pick up your office phone. Reach out to the Phoebe team to set this up.',
    'You can skip caregivers you do not want to reach out.',
    'Phoebe works with thousands of caregivers.',
] as const;
